import { Card, CardContent, Typography } from '@material-ui/core';
import { FC } from 'react';

import config from './config.json';

const alert = config.alert as { title: string; text: string } | null;

const RegistrationClosed: FC = () => <Card variant="outlined">
  <CardContent>
    <Typography variant="h5" component="h2" gutterBottom>{alert?.title ?? 'Anmeldung geschlossen'}</Typography>
    {alert
      ? <Typography variant="body1" component="div" gutterBottom>
          <div dangerouslySetInnerHTML={{ __html: alert.text }} />
        </Typography>
      : <Typography variant="body1" gutterBottom>
          Die Anmeldung für das Boni-Arche-Camp wurde bereits geschlossen.<br />
          Vielen Dank für Ihr Interesse.
        </Typography>}
  </CardContent>
</Card>

export default RegistrationClosed;
